<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/introductionthefiresofinspiration"><span class="item-title-text">Introduction: The Fires of Inspiration</span></a></p>
<p class="item-author">Kevin J. Anderson</p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/splendidmiragetheseekerstale"><span class="item-title-text">Splendid Mirage: The Seeker’s Tale</span></a></p>
<p class="item-author">Kevin J. Anderson &amp; Neil Peart</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/thefiresermon"><span class="item-title-text">The Fire Sermon</span></a></p>
<p class="item-author">Mary Pletsch</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/onehitwebster"><span class="item-title-text">One-Hit Webster</span></a></p>
<p class="item-author">Brian Corley</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/thedoor"><span class="item-title-text">The Door</span></a></p>
<p class="item-author">Kristen Bickerstaff</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/theburrenofmars"><span class="item-title-text">The Burren of Mars</span></a></p>
<p class="item-author">CJ Erick</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/whitefeather"><span class="item-title-text">White Feather</span></a></p>
<p class="item-author">Shannon Fox</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/intothevalley"><span class="item-title-text">Into the Valley</span></a></p>
<p class="item-author">Wayland Smith</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/thelastwakingprincess"><span class="item-title-text">The Last Waking Princess</span></a></p>
<p class="item-author">Kat Kellermeyer</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/thefirstproblem"><span class="item-title-text">The First Problem</span></a></p>
<p class="item-author">Alicia Cay</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/mijaculpo"><span class="item-title-text">Mi Jaculpo</span></a></p>
<p class="item-author">October K Santerelli</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/oneforhungertwoforjoy"><span class="item-title-text">One for Hunger, Two for Joy</span></a></p>
<p class="item-author">Tanya Hales</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/thehunterandthehunted"><span class="item-title-text">The Hunter and the Hunted</span></a></p>
<p class="item-author">Raphyel M. Jordan</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/takemeforaride"><span class="item-title-text">Take Me for a Ride</span></a></p>
<p class="item-author">Mike Jack Stoumbos</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/hydepark"><span class="item-title-text">Hyde Park</span></a></p>
<p class="item-author">Shannon Fox</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/bowdrill"><span class="item-title-text">Bow Drill</span></a></p>
<p class="item-author">Jace Killan</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/dreamgirl"><span class="item-title-text">Dream Girl</span></a></p>
<p class="item-author">Kitty Sarkozy</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/whitesailsandstormyseas"><span class="item-title-text">White Sails and Stormy Seas</span></a></p>
<p class="item-author">M. Elizabeth Ticknor &amp; Rebecca E. Treasure</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/checkyesorno"><span class="item-title-text">Check Yes or No</span></a></p>
<p class="item-author">Melissa Koons</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-author has-no-children">
<p class="item-title"><a href="#/dontignoreit"><span class="item-title-text">Don’t Ignore It</span></a></p>
<p class="item-author">Tanya Hales</p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/abouttheeditor"><span class="item-title-text">About the Editor</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/ifyouliked"><span class="item-title-text">If You Liked …</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/otherwordfirepresstitleseditedbylisamangum"><span class="item-title-text">Other WordFire Press Titles Edited by Lisa Mangum</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?476aef3a